import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const RegistrationPreview = () => {
  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h2 className="mb-5">Business Registration</h2>
            <h3 className="mb-5">
              Please read before you begin registration
            </h3>
            <p>
              By registering on this website, your business will receive notification of government opportunities and the capability 
              to search for business partners and government business opportunities.
            </p>
            <p>
              In order to use most of MatchForce's capabilities, including receiving government opportunities, businesses should be 
              prepared to provide all or most of the following information during registration:
            </p>
            <ul className="green-dots-list">
              <li>
                <p>
                  Email address
                </p>
              </li>
              <li>
                <p>
                  Business name
                </p>
              </li>
              <li>
                <p>
                  Contact name
                </p>
              </li>
              <li>
                <p>
                  Business type
                </p>
              </li>
              <li>
                <p>
                  Business description
                </p>
              </li>
              <li>
                <p className="mb-2">
                  Business keywords
                </p>
                <p className="add-p">
                  (examples for a locksmith may include <span>&nbsp;lock, key, safe, locksmith, door,  security system...&nbsp;</span> these keywords are critical because they 
                  generate the matches with micro purchase opportunities!)
                </p>
              </li>
              <li>
                <p className="mb-2">
                  NAICS codes
                </p>
                <p className="add-p">
                  (Matches are generated based on NAICS and/or PSC codes. Please be sure to include one or both in your profile.)
                </p>
              </li>
              <li>
                <p className="mb-2">
                  PSC codes
                </p>
                <p className="add-p">
                  (Matches are generated based on PSC and/or NAICS codes. Please be sure to include one or both in your profile.)
                </p>
              </li>
              <li>
                <p>
                  If you accept credit cards
                </p>
              </li>
              <li>
                <p>
                  Any shipping and delivery terms
                </p>
              </li>
              <li>
                <p>
                  Any discounts
                </p>
              </li>
              <li>
                <p>
                  Tax ID number
                </p>
              </li>
              <li>
                <p>
                  Applicable SBA Contracting Assistance Programs (8a, HUBZone, etc)
                </p>
              </li>
              <li>
                <p>
                  GSA contract number and expiration date
                </p>
              </li>
              <li>
                <p>
                  DUNS Unique Entity ID
                </p>
              </li>
               <li>
                <p>
                  UEI (Unique Entity Identifier)
                </p>
              </li>
              <li>
                <p>
                  SAM Unique Entity ID
                </p>
              </li>
              <li>
                <p>
                  CAGE code
                </p>
              </li>
            </ul>
            <Link to="/registration?role=business" className="btnSizes filledBtn py-3">
              Proceed to Registration
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default RegistrationPreview;